import { Box } from "@mui/material";

//import DataGrid from "devextreme-react/data-grid";

import useMediaQuery from "@mui/material/useMediaQuery";

import { useDispatch, useSelector } from "react-redux";
import Header from "../../../components/Header";
import GrievanceReport7List from "../../../components/reports/grievance/grievanceList7";

const GrievanceReport7 = () => {
  const filter = useSelector((state) => state.report.filter);
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const dispatch = useDispatch();

  return (
    <Box m="20px">
      <Header title="Санал хүсэлт тайлан" subtitle="Захиргааны гомдол" />

      <Box
        display="grid"
        gap="30px"
        gridTemplateColumns="repeat(12, minmax(0, 1fr))"
        sx={{
          "& > div": { gridColumn: isNonMobile ? undefined : "span 12" },
        }}
      >
        {/* <Box sx={{ gridColumn: "span 3" }}>
          <FilterBox getFilters={setFilters} />
        </Box> */}
        <Box sx={{ gridColumn: "span 12" }}>
          <GrievanceReport7List />
        </Box>
      </Box>
    </Box>
  );
};

export default GrievanceReport7;
